import request from '@/utils/request'
//获取sso域名
export function getssoUrl(data) {
  return request({
    url: '/channelSite/domain/info' ,
    // url: '//192.168.26.179:6601/api/v1/oem/webSite/ssoChannel' ,
    method: 'post',
    data
  })
}
// 登录接口
export const ssologion = ticket => {
  return request({
    // url: '/login/' + ticket,
    url: '/ssologin?ticket=' + ticket,
    method: 'get'
  })
}
// get user info
// export function getInfo() {
//   return request({
//     url: '/channel',
//     method: 'get'
//   })
// }

// 获取权限菜单
export const getUserInfo = token => {
  return request({
    url: '/open/menu',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 第一次登录判断
// v20/first/access/app
export const getoncelogin = () => {
  return request({
    url: '/first/access/app',
    method: 'get'
  })
}

// 获取应用title
export function getBaseSettingTitle(data) {
  return request({
    url: '/channelSite/info',
    method: 'POST',
    data
  })
}
